import { MutationTree } from "vuex";
import { AppState } from "@/store/mainStore/state";
import PageContext from "@/entities/page.context";
import { Modal } from "@/entities/modal";

export const mutations: MutationTree<AppState> = {
  setPageContext(state: AppState, payload: PageContext): void {
    state.pageContext = payload;
  },
  setMobileView(state: AppState, payload: boolean): void {
    state.isMobileView = payload;
  },
  setModal(state: AppState, payload: Modal): void {
    state.modal = payload;
  },
  updateMarketResult(state: AppState, payload:  Map<string, {answer: string, eventId:string, marketId: string, isSubmited: boolean, submitedAns: string}>): void {
    state.marketResult = payload;
  }
}